<template lang="html">
  <div class="mng-editor-content">
    <div class="mng-editor-panel">
      <div class="mng-editor-panel__block mng-editor-panel__block--last">
        <div class="mng-editor-panel__label">
          加载背景
        </div>
        <div class="image-uploads">
          <div>
            <div v-show="removeIconM" class="image-uploads__imageremove" @click="removeThumb(0)">
              -
            </div>
            <AiImageUpload ref="phone_uploader"
                           text="上传照片"
                           sub="(建议尺寸9:16)"
                           accept="image/*"
                           class="image-uploads__upload"
                           @change="onPhoneImageChanged"
                           @imagescale="onPhoneImageScale"
                           @filesize="onPhoneImageSize" />
            <div class="image-uploads__text">
              移动端
            </div>
          </div>
          <div>
            <div v-show="removeIconP" class="image-uploads__imageremove" @click="removeThumb(1)">
              -
            </div>
            <AiImageUpload ref="pc_uploader"
                           text="上传照片"
                           sub="(建议尺寸16:9)"
                           accept="image/*"
                           class="image-uploads__upload"
                           @change="onPCImageChanged"
                           @imagescale="onPCImageScale"
                           @filesize="onPCImageSize" />
            <div class="image-uploads__text">
              PC端
            </div>
          </div>
        </div>
      </div>
      <!-- Hide logo upload -->
      <!-- <div class="mng-editor-panel__block mng-editor-panel__block--last">
        <div class="mng-editor-panel__label">
          加载LOGO
        </div>
        <AiImageUpload text="上传LOGO"
                       class="image-uploads__upload image-uploads__upload--single"
                       accept="image/*"
                       @change="onLogoImageChanged" />
      </div> -->

      <div class="ai-button ai-button--primary mng-editor-panel__button"
           @click="updateImages">
        保存所有设置
      </div>
    </div>
    <div ref="preview" class="mng-editor-preview preview-loading">
      <div class="preview__wrapper" :style="previewStyle">
        <div class="preview preview--phone" :style="phoneStyle">
          <div class="preview__image">
            <img class="preview__image-background" :src="pendings.phone || previews.phone" alt="">
            <!-- <img class="preview__image-logo" :src="pendings.logo || previews.logo" alt=""> -->
            <!-- <div class="preview__loading-indicator-mobile">
              <div class="preview__loading-progress-mobile" />
            </div> -->
          </div>
          <span class="preview__label">移动端加载界面</span>
        </div>
        <div class="preview preview--pc" :style="pcStyle">
          <div class="preview__image">
            <img class="preview__image-background" :src="pendings.pc || previews.pc" alt="">
            <!-- <img class="preview__image-logo" :src="pendings.logo || previews.logo" alt=""> -->
            <!-- <div class="preview__loading-indicator-desktop">
              <div class="preview__loading-progress-desktop" />
            </div> -->
          </div>
          <span class="preview__label">PC端加载界面</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  /* eslint-disable */
  data() {
    return {
      previewStyle: {},
      phoneStyle: {},
      pcStyle: {},
      showThumb: false,
      previews: {
        phone: '',
        pc: '',
        logo: ''
      },
      pendings: {
        phone: '',
        pc: '',
        logo: ''
      },
      removeIconM: false,
      removeIconP: false
    };
  },
  mounted() {
    window.addEventListener('resize', this.updatePreviewStyle);
    this.updatePreviewStyle();
    this.loadImages();
  },
  beforeDestroy() {
    // do something before destroying vue instance
    window.removeEventListener('resize', this.updatePreviewStyle);
  },
  methods: {
    updatePreviewStyle() {
      const { preview } = this.$refs;
      const previewHeight = preview.clientHeight;
      const previewWidth = preview.clientWidth - 140;
      let base;
      if ((previewWidth - 112) / (previewHeight - 49) > 337 / 144) {
        base = (previewHeight - 49) / 16;
        this.previewStyle = {
          width: `${base * 337 / 9 + 112}px`,
          height: '100%'
        };
      } else {
        base = (previewWidth - 112) * 9 / 337;
        this.previewStyle = {
          width: '100%',
          height: `${base * 16 + 49}px`
        };
      }
      this.phoneStyle = {
        width: `${base * 9}px`
      };
      this.pcStyle = {
        width: `${base * 256 / 9}px`
      };
    },
    onPhoneImageScale(scale){
      if(scale!==0.5625)
      {
       // this.$message('尺寸不为 9 : 16');
      }
    },
    onPCImageScale(scale){
      if(Math.abs(scale-1.7777777)>0.2)
      {
      //  this.$message('尺寸不为 16 : 9');
      }
    },
    onPhoneImageSize(size) {
       this.phonesize = size / Math.pow(1024, 2);
      if (this.phonesize > 2) {
        this.$message('图片尺寸大于2M,请重新选择');
      }
    },
    onPCImageSize(size) {
       this.pcsize = size / Math.pow(1024, 2);
      if (this.pcsize > 2) {
        this.$message('图片尺寸大于2M,请重新选择');
      }
    },
    onPhoneImageChanged(src) {
      this.pendings.phone = src;
      if(src)
      this.removeIconM = true;
      else this.removeIconM = false;
    },
    onPCImageChanged(src) {
      this.pendings.pc = src;
      if(src)
      this.removeIconP = true;
      else this.removeIconP = false;
    },
    removeThumb(pc) {
      if(pc)
      {
        this.pendings.pc = null;
        this.$refs.pc_uploader.clear();

      }
      else
      {
        this.pendings.phone = null;
        this.$refs.phone_uploader.clear();
      }
    },
    onLogoImageChanged(src) {
      this.pendings.logo = src;
    },
    async loadImages() {
      try {
        const { data: { data } } = await this.$http.post(
          '/admin/get-store-info?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so',
          { store_id: this.$route.params.modelId }
        );
        this.previews.phone = data.phone_loading_picture;
        this.previews.pc = data.desktop_loading_picture;
        this.previews.logo = data.logo;
      } catch (error) {
        this.$log(error.error_msg);
      }
    },
    async updateImages() {

      if (this.phonesize > 2) {
        this.$message('手机图片大于2M,请重新选择');
        return;
      }

      if (this.pcsize > 2) {
        this.$message('pc图片大于2M,请重新选择');
        return;
      }      
      const payload = { store_id: this.$route.params.modelId };
      if (this.pendings.phone.length) payload.phone_loading_picture = this.pendings.phone.replace(/data:image.*?,/gi, '');
      if (this.pendings.pc.length) payload.desktop_loading_picture = this.pendings.pc.replace(/data:image.*?,/gi, '');
      if (this.pendings.logo.length) payload.logo = this.pendings.logo.replace(/data:image.*?,/gi, '');

      try {
        const { data } = await this.$http.post(
          '/admin/modify-store-loading-pictures?secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so',
          payload
        );
        if (data.error_no === 200) {
          this.$message('修改成功');
          this.loadImages();
        } else {
          this.$log(data.error_msg);
        }
      } catch (error) {
        this.$log(error.error_msg || error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.preview-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100vw - 480px);
  min-width: 660px;
  padding: 0 70px;

  & > div {
    height: 100%;
  }
}

.preview {
  background-color: #666;
  display: inline-flex;
  position: relative;
  height: calc(100% - 49px);
  padding: 9px 8px 40px;
  border-radius: 8px;

  &--phone {
    margin-right: 80px;
  }

  &__image {
    width: 100%;
    height: 100%;
    background-color: #3c3c3c;
    position: relative;
    display: flex;
  }

  &__image-background {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &__image-logo {
    width: 40px;
    height: 40px;
    position: absolute;
    top: calc(50% - 20px);
    left: calc(50% - 20px);
    object-fit: cover;
  }

  &__label {
    position: absolute;
    width: 100%;
    bottom: -50px;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #fff;
    user-select: none;
  }
}

.image-uploads {
  display: flex;
  justify-content: space-between;
  padding: 0 27px;

  &__upload {
    margin-bottom: 12px;

    &--single {
      margin: 0 27px;
    }
  }

  &__text {
    color: #666;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    user-select: none;

    &--sub {
      font-size: 8px;
    }
  }

  &__imageremove {
    position: absolute;
    margin-top: 5px;
    margin-left: 85px;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background-color: #f50;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    cursor: pointer;
    user-select: none;
  }

}
</style>
